import React, { useEffect } from 'react';
import Footer from '../components/Footer';

import cat1 from '../images/wedding.jpg'
import cat2 from '../images/wedding2.jpg'
import cat3 from '../images/engagement.jpg'
import cat4 from '../images/birthday.jpg'

import cat5 from '../images/birthday2.jpg'
import cat6 from '../images/newyear.jpg'
import cat7 from '../images/marrge.jpg'
import cat8 from '../images/marrge2.jpg'



const Category = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>


            <div className='headings'>
                <h3>OUR EVENT CATEGORY</h3>
            </div>
            <div className='productcatogorey'>



                <div className='product2'>

                    <div className='product3'>
                        <img src={cat1} />
                    </div>

                    <div className='product3'>
                        <img src={cat2} />
                    </div>

                    <div className='product3'>
                        <img src={cat3} />
                    </div>

                    <div className='product3'>
                        <img src={cat4} />
                    </div>

                </div>
                <div className='product2'>

                    <div className='product3'>
                        <img src={cat5} />
                    </div>

                    <div className='product3'>
                        <img src={cat6} />
                    </div>

                    <div className='product3'>
                        <img src={cat7} />
                    </div>

                    <div className='product3'>
                        <img src={cat8} />
                    </div>

                </div>






                <br />
            </div>
            <Footer />
        </>
    );
};

export default Category;